import React, { useEffect } from "react";
import { Header } from "../../components/Header";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { BASE_URL_API } from "../../components/Constants";
import { useState } from "react";
import { CLIENT_SECRET } from "../../components/Constants";
import { CLIENT_ID } from "../../components/Constants";
import crypto from 'crypto-js';
import { decryptAES } from "../../components/CryptoUtils";
import { DATA_DECRYPTION_KEY } from "../../components/Constants";
import { decryptUserData } from "../../Pages/userCrypto";
import { getInitials } from "../../components/Helper";
import Skeleton, { SkeletonTheme } from "react-loading-skeleton";
import { useUser } from "../../ContextApi/UserContext";
import { BASE_URL_OPENFORGE } from "../../components/Constants";
import { useLocation } from "react-router-dom";
import { useParams } from 'react-router-dom';
import { encryptAES } from "../../components/CryptoUtils";
import { IMAGE_PATH_Leader } from "../../components/Constants";
import { DEFAULT_USER_IMAGE } from "../../components/Constants";







export default function UserProfileView() {

  const navigate = useNavigate();
  const location = useLocation();
  const { user, isLoggedIn ,isLoading: userLoading} = useUser();
  // const userLoading = false;
  // const isLoggedIn = true;
    // const user = { id: 71983, realname: "sushant", username: "sushantshekhar", email: "sushantpu@example.com", joined_on: "Jan 13, 2025" };

  const  paramsuserName  = useParams(); 
  



  const [profileData, setProfileData] = useState({})
  const [certificateData, setCertificateData] = useState([])
  const [projectData, setProjectData] = useState([])
  const [isLoading, setIsLoading] = useState(false);
  const [profileUrl, setProfileUrl] = useState(null);
  const [showProfile,setShowProfile] = useState(true);

  const [masterData, setMasterData] = useState({
    qualifications: [],
    employement_type: [],
    programming_languages: [],
    frameworks: [],
    state: [],
    roles: [],
    ministry_list: [],
    departments_list: [],
    designations_list: [],
    institute_name: [],
  });


  const fetchUserInfo = async (md) => {
    try {
      const formData = new FormData();
      const ts = Math.floor(Date.now() / 1000);
      formData.append("client_id", CLIENT_ID);
      formData.append("ts", ts);
      
      
      if(user.username!==paramsuserName.name) {
        const hmacStr = CLIENT_SECRET + CLIENT_ID + paramsuserName.name.toString() +  ts.toString();
        const hmacHash = crypto.SHA256(hmacStr).toString(crypto.enc.Hex);
        formData.append("hmac", hmacHash);

        formData.append("user_name", paramsuserName.name);
        setShowProfile(false);
      }
      else{
      const hmacStr = CLIENT_SECRET + CLIENT_ID + user.id +  ts.toString();
      const hmacHash = crypto.SHA256(hmacStr).toString(crypto.enc.Hex);
      formData.append("hmac", hmacHash);

      formData.append("user_id", user.id);
      }
      const jsonObject = {};
      formData.forEach((value, key) => {
        jsonObject[key] = value;
      });
      
      const jsonString = JSON.stringify(jsonObject);
      
      const encrypted = await encryptAES(jsonString, DATA_DECRYPTION_KEY);
      
      const secureFD = new FormData();
      secureFD.append("request_data", encrypted);
       
      const response = await axios.post(`${BASE_URL_API}get_user_additional_profile`, secureFD, {})
      if (response.status === 200) {
        const responseData = response.data.data;
        const decryptedText = await decryptAES(
          responseData,
          DATA_DECRYPTION_KEY
        );
        const data = await JSON.parse(decryptedText)[0];


        const skills = data.skills || { language: [], framework: [] };

        // Map language IDs to names
        const languageIds = (skills.language || []).map(s => s.lang_id);
        const languages = languageIds
          .map(id => md.programming_languages.find(lang => Number(lang.id) === Number(id))?.name)
          .filter(Boolean);

        // Map framework IDs to names
        const frameworkIds = (skills.framework || []).map(s => s.lang_id);
        const frameworks = frameworkIds
          .map(id => md.frameworks.find(f => Number(f.id) === Number(id))?.name)
          .filter(Boolean);

        const formatType = (value) => {
          if (!value) return "";

          const v = value.toLowerCase();

          if (v === "thirdparty") return "ThirdParty";
          if (v === "contractual") return "Contractual";

          return v.charAt(0).toUpperCase() + v.slice(1);
        };
        const formatDate = (input) => {
        if (!input) return "-";

        let date;

        if (typeof input === "number" || /^\d+$/.test(input)) {
        const ts = Number(input);
        date = new Date(ts < 1e12 ? ts * 1000 : ts);
        } else {
        date = new Date(input.replace(",", ""));
        }

        if (isNaN(date.getTime())) return "-";

        return date
        .toLocaleDateString("en-US", {
          day: "2-digit",
          month: "short",
          year: "numeric",
        })
        };


        const enriched = {
          ...data,
          joined_on: formatDate(data.joined_on),
          employment_type: formatType(data.employment_type),
          payroll_company_nature: formatType(data.payroll_company_nature),
          designation:md.designations_list.find(d => Number(d.id) === Number(data.designation))?.name || "",
          highest_qualification: md.qualifications.find(q => Number(q.id) === Number(data.highest_qualification))?.name || "",
          institution_name: md.institute_name.find(q => Number(q.org_id) === Number(data.institution_id))?.name || "",
          current_role_position: md.roles.find(r => Number(r.id) === Number(data.current_role_position))?.name || "",
          state: md.state.find(s => Number(s.id) === Number(data.state_id))?.name || "",
          ministry: md.ministry_list.find(m => Number(m.id) === Number(data.associated_ministry))?.name || "",
          languages: languages.join(", "),
          frameworks: frameworks.join(", "),
        };
        let imageUrl = "";

        if (data?.profile_image) {
          imageUrl = `${IMAGE_PATH_Leader}/profile_images/${data.profile_image.split("/").pop()}`;
          setProfileUrl(imageUrl);

        }else{

            setProfileUrl(DEFAULT_USER_IMAGE)
        }

        setProfileData(enriched);
      } else {
        setProfileData({});
      }
    } catch (error) {
      setProfileData({})
      console.error("There was a problem fetching the tasks:", error)
    }

  }


  const fetchUserCertificates = async () => {
    try {
      const ts = Math.floor(Date.now() / 1000);
      const hmacStr = CLIENT_SECRET + CLIENT_ID + user.id.toString() + ts.toString();
      const hmacHash = crypto.SHA256(hmacStr).toString(crypto.enc.Hex);
      const fd = new FormData();
      fd.append("user_id", user.id);
      fd.append("client_id", CLIENT_ID);
      fd.append("ts", ts);
      fd.append("hmac", hmacHash);
      const response = await axios.post(`${BASE_URL_API}get_certificates`, fd, {})
      if (response.data.code === 200) {
        if (response.data.secure) {
          const encryptedData = await response.data.data;
          const decryptedText = await decryptAES(encryptedData, DATA_DECRYPTION_KEY);
          const output = JSON.parse(decryptedText);
          setCertificateData(output)
        } else {
          setCertificateData([])
        }
      } else {
        setCertificateData([])
      }
    } catch (error) {
      setCertificateData([])
      console.error("There was a problem fetching the tasks:", error);
    }

  }


  const fetchUserProject = async () => {
    try {
      const fd = new FormData();
      fd.append("user_name", paramsuserName.name);
      const response = await axios.post(`${BASE_URL_API}get_project_list`, fd, {})
      if (response.status === 200) {
        setProjectData(response.data.data)
      } else {
        setProjectData([])
      }
    } catch (error) {
      setProjectData([])
      console.error("There was a problem fetching the tasks:", error);
    }

  }

  const getUniversityList = async () => {
    try {
      const res = await axios.post(`${BASE_URL_API}get_university_cls_list`);
      setMasterData((prev) => ({
        ...prev,
        institute_name: res.data.data.records,
      }));
      return res.data.data.records;
    } catch (err) {
      console.error("Error fetching university list:", err);
      return []
    }
  };

  const fetchMasterData = async (key) => {
    try {
      const formData = new FormData();
      formData.append("key", key);
      const response = await axios.post(`${BASE_URL_API}get_master_data`, formData, {});

      setMasterData((prev) => ({
        ...prev,
        [key]: response.data.data,
      }));
      return response.data.data;
    } catch (error) {
      console.error(`Error fetching ${key} data:`, error.response?.data || error);
      return [];
    }
  };

  const fetchState = async (key) => {
    try {

      const response = await axios.post(`${BASE_URL_API}get_state_list`, {});
      setMasterData((prev) => ({
        ...prev,
        [key]: response.data.data,
      }));
      return response.data.data;

    } catch (error) {
      console.error(`Error fetching ${key} data:`, error.response?.data || error);
      return [];
    }
  };


  useEffect(() => {
    if (!isLoggedIn || !user) return;

    const fetchAll = async () => {
      setIsLoading(true);
      try {
        const [
          qualifications,
          programming_languages,
          frameworks,
          employement_type,
          roles,
          ministry_list,
          departments_list,
          designations_list,
          state,
          institute_name,
        ] = await Promise.all([
          fetchMasterData("qualifications"),
          fetchMasterData("programming_languages"),
          fetchMasterData("frameworks"),
          fetchMasterData("employement_type"),
          fetchMasterData("roles"),
          fetchMasterData("ministry_list"),
          fetchMasterData("departments_list"),
          fetchMasterData("designations_list"),
          fetchState("state"),
          getUniversityList()
        ]);

        const md = {
          qualifications,
          programming_languages,
          frameworks,
          employement_type,
          roles,
          ministry_list,
          departments_list,
          designations_list,
          state,
          institute_name,
        }
        await fetchUserInfo(md);

        await Promise.all([fetchUserCertificates(), fetchUserProject()]);

      } catch (error) {
        console.error("Error fetching user data:", error);
      } finally {
        setIsLoading(false);
      }
    };
    fetchAll();
  }, [isLoggedIn, user?.id]);

  const formatDOB = (dobString) => {
    if (!dobString) return "-";

    // Force correct parsing: Convert to Date object safely
    const dob = new Date(Date.parse(dobString.replace(',', '')));
    const today = new Date();

    // --- FORMAT "DD MMM YYYY" ---
    const formattedDate = dob.toLocaleDateString("en-US", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    });

    // --- AGE CALCULATION ---
    let age = today.getFullYear() - dob.getFullYear();
    const monthDiff = today.getMonth() - dob.getMonth();

    if (
      monthDiff < 0 ||
      (monthDiff === 0 && today.getDate() < dob.getDate())
    ) {
      age--;
    }

    // Prevent negative / wrong age
    if (age < 0) age = 0;

    return `${formattedDate} (${age} years) `;
  };




  const handleLogin = () => {
    const redirectUrl = location?.pathname ? location.pathname : null;

    if (redirectUrl) {
      localStorage.setItem("redirectUrl", redirectUrl);
    }

    //const redirectUrlGet = localStorage.getItem("redirectUrl");
    //const url = ${BASE_URL_OPENFORGE}${redirectUrlGet};

    window.location.href = `${BASE_URL_OPENFORGE}/account/login.php?requested_by=collabwithgov`;
  };


  // EARLY RETURN if not logged in
  if (!isLoggedIn || !user) {
    return (
      <>
        <Header />
        <div style={{ marginTop: 100, textAlign: 'center', color: '#555', height: '50vh' }}>
          Please <span onClick={handleLogin} style={{ color: 'blue', textDecoration: 'underline', cursor: 'pointer' }}>log in</span> to view your profile.
        </div>
      </>
    );
  }


  // // EARLY RETURN if not logged in
  // if (!isLoggedIn || !user) {
  //   return (
  //     <>
  //       <Header />
  //       <div style={{ marginTop: 50, textAlign: 'center', color: '#555' }}>
  //         Please log in to view your profile.
  //       </div>
  //     </>
  //   );
  // }
  // useEffect(() => {
  //   if (userLoading) return;              // Wait for PHP session check to finish

  //   if (!isLoggedIn) {                // User NOT logged in → redirect once
  //     const redirectUrl = location?.pathname || "/";
  //     localStorage.setItem("redirectUrl", redirectUrl);

  //     window.location.href =
  //       `${BASE_URL_OPENFORGE}/account/login.php?requested_by=collabwithgov`;
  //   }
  // }, [userLoading, isLoggedIn]);

  // // ---- RETURN LOGIC ----

  // if (userLoading) return null;           // Still verifying login
  // if (!isLoggedIn) return null;       // Redirect already triggered

  // // User is logged in, but user data hasn't loaded yet
  // if (!user) return null;             // Prevents "realname undefined" crash


  return (
    <main>
      <Header />
      <div className="split-background">
        <style>{`
          .split-background {
            min-height: 100vh;
            width: 100%;
            background: linear-gradient(
              to bottom,
              #00675b 0,
              #00675b 30%,
              #ffffff 30%,
              #ffffff 100%
            );
            background-repeat: no-repeat;
            background-size: 100% 100%;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: flex-start;
            padding-top: 100px;
            padding-bottom: 50px;
          }

          .card {
            border-radius: 12px !important;
            background: #fff;
          }

          .profile-circle {
            width: 120px;
            height: 120px;
            border-radius: 50%;
            background-color:  rgba(170, 246, 237, 1);
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 28px;
            font-weight: bold;
            color: rgba(0, 103, 91, 1);
                }

          .name {
            font-family: Roboto, sans-serif;
            font-weight: 600;
            font-size: 32px;
            color: rgba(0, 103, 91, 1);
            line-height: 40px;
          }

          .heading {
            font-size: 22px;
            font-weight: 600;
            margin-bottom: 10px;
            color: rgba(0, 103, 91, 1);
            text-align: left;
          }

         .info-block {
            margin-bottom: 12px;
          }

        .divider {
          width: 100%;
          height: 1px;
          background-color: #e2e2e2;
          margin-bottom: 12px;
        }

        .info-label {
          font-weight: 500;
          color: #555;
        }

        .info-value {
          font-weight: 500;
          color: #333;
        }

        .section-wrapper {
          margin-bottom: 2rem;
        }

        .section-wrapper .heading {
          font-size: 22px;
          font-weight: 600;
          margin-bottom: 12px; /* spacing between heading and box */
          color: rgba(0, 103, 91, 1);
          text-align: left;
          padding-left: 12px; /* aligns heading with box content */
        }
  

          /* ===== Responsive ===== */
          @media (max-width: 992px) {
            .name { font-size: 26px; }
            .profile-circle { width: 100px; height: 100px; font-size: 24px; }
          }

          @media (max-width: 768px) {
            .split-background { padding-top: 100px; }
            .card { padding: 1rem !important; }
            .name { font-size: 22px; line-height: 32px; text-align: center; }
          }

          @media (max-width: 576px) {
            .profile-circle { width: 80px; height: 80px; font-size: 20px; }
            .name { font-size: 20px; }
            .heading { font-size: 18px; text-align: left; }
          }
        `}</style>
        {
          (isLoading)
            ?
            <SkeletonTheme baseColor="#ebebeb" highlightColor="#fff">
              <div
                style={{
                  width: "100%",
                  minHeight: "calc(100vh - 150px)",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <div
                  style={{
                    width: "950px",
                    maxWidth: "95%",
                    background: "#fff",
                    borderRadius: 16,
                    padding: "16px 8px",
                    boxShadow: "0 4px 8px rgba(0,0,0,0.2)",
                  }}
                >
                  <div className="d-flex justify-content-end mb-3">
                    <Skeleton width={80} height={28} />
                  </div>
                  <div className="d-flex align-items-center mb-4">
                    <Skeleton circle width={120} height={120} />
                    <div style={{ marginLeft: 16, flex: 1 }}>
                      <Skeleton height={28} width="60%" style={{ marginBottom: 10 }} />
                      <Skeleton height={20} width="40%" style={{ marginBottom: 6 }} />
                      <Skeleton height={20} width="50%" />
                    </div>
                  </div>
                  <Skeleton height={25} width="30%" style={{ marginBottom: 10 }} />
                  <Skeleton count={3} />
                  <Skeleton height={25} width="40%" style={{ marginTop: 20, marginBottom: 10 }} />
                  <Skeleton count={2} />
                  <Skeleton height={25} width="50%" style={{ marginTop: 20, marginBottom: 10 }} />
                  <Skeleton count={3} height={40} style={{ marginBottom: 8 }} />
                  <Skeleton height={25} width="50%" style={{ marginTop: 20, marginBottom: 10 }} />
                  <div className="d-flex gap-2">
                    <Skeleton width={100} height={100} />
                    <Skeleton width={100} height={100} />
                    <Skeleton width={100} height={100} />
                  </div>
                </div>
              </div>
            </SkeletonTheme>
            :
            (
              <div
                style={{
                  background: "#fff",
                  borderRadius: 16,
                  boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
                  padding: "16px 8px",
                  width: "950px",
                  maxWidth: "95%",
                }}
              >
                <div className="d-flex justify-content-end">
                 { showProfile ?
                  <button
                    onClick={() => navigate("/users/edit")}
                    className="btn"
                    style={{
                      fontWeight: "500",
                      color: "rgba(0, 103, 91, 1)",
                    }}
                  >
                    Edit Profile
                  </button>
                  : <></>}
                </div>
                <div className="card mb-4 p-4 shadow-sm">
                  <div className="container mt-2 mb-3">
                    <div className="row align-items-center text-center text-md-start">
                      <div className="col-12 col-md-2 mb-3 mb-md-0 d-flex justify-content-center justify-content-md-start">
                        <div className="profile-circle"
                          style={{
                            position: "relative",
                            overflow: "hidden",
                            width: "100px",
                            height: "100px",
                            borderRadius: "50%",
                          }}>
                          {profileUrl ? (
                            <img
                              src={profileUrl}
                              alt="Profile"
                              style={{
                                width: "100%",
                                height: "100%",
                                objectFit: "cover",
                              }}
                              className="profile-img"
                            />
                          ) : (
                            <span >{profileData ? getInitials(profileData.realname) : ''}</span>
                          )}
                        </div>
                      </div>
                      <div className="col-12 col-md-9">
                        <h4 className="mt-3 mt-md-0 mb-1 name">{profileData.realname}</h4>
                        <p className="text-muted mb-0">{profileData.user_name}</p>
                      {showProfile ?  <p className="text-muted mb-0">{user.email}</p> : <></>} 
                        <div className="d-flex justify-content-between align-items-center mt-1">
                          <p className="text-muted mb-0">
                          {showProfile ? <> {profileData.gender}{profileData.gender && " | "} {formatDOB(profileData.dob) || "-"} </> : <></>}
                          </p>
                          <p className="text-secondary mb-0 text-end">
                            Joined: {profileData?.joined_on || ""}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                  {showProfile ? 
                   <div className="mt-4">
                    <h5 className="heading">About Me</h5>
                    <div className="about-me-text">{profileData.about_me || "-"}</div>
                  </div>
                   : <></>}
                 
                </div>
                {showProfile ?
                <>
                <div className="section-wrapper mb-4">
                  <h5 className="heading">Educational Information</h5>
                  <div className="card p-4 shadow-sm">
                    <div className="row g-3">
                      <div className="col-4">
                        <div className="info-block">
                          <div className="info-label">Qualification: </div>
                          <div className="info-value">{profileData.highest_qualification || "-"}</div>
                        </div>
                      </div>
                      <div className="col-4">
                        <div className="info-block">
                          <div className="info-label">Institute: </div>
                          <div className="info-value">{profileData.institution_name || "-"}</div>
                        </div>
                      </div>
                      <div className="col-4">
                        <div className="info-block">
                          <div className="info-label">Year of Passing: </div>
                          <div className="info-value">{profileData.year_of_passing || "-"}</div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="section-wrapper mb-4">
                  <h5 className="heading">Professional & Organizational Information</h5>
                  <div className="card p-4 shadow-sm">
                    <div className="row g-3">
                      <div className="col-4">
                        <div className="info-block">
                          <div className="info-label">Employment Type: </div>
                          <div className="info-value">{profileData.employment_type || "-"}</div>
                        </div>
                      </div>
                      <div className="col-4">
                        <div className="info-block">
                          <div className="info-label">
                            {profileData.employment_type === "Private" ? "Government Association" : "Associated Ministry"}
                          </div>
                          <div className="info-value">
                            {profileData.employment_type === "Private"
                              ? profileData.govt_association || "-"
                              : profileData.ministry || "-"}
                          </div>
                        </div>
                      </div>
                      <div className="col-4">
                        <div className="info-block">
                          <div className="info-label">Organization / Department: </div>
                          <div className="info-value">
                            {Number(profileData.organization_department_name) === Number(5000) && profileData.other_organization_department_name
                            ? `Others - ${profileData.other_organization_department_name}`
                            : masterData?.departments_list.find(
                              d => Number(d.id) === Number(profileData.organization_department_name)
                              )?.name || "-"}
                          </div>
                        </div>
                      </div>

                      {profileData.employment_type === "Private" && (
                        <div className="col-4">
                          <div className="info-block">
                            <div className="info-label">If Govt Associated: </div>
                            <div className="info-value">{profileData.payroll_company_nature || "-"}</div>
                          </div>
                        </div>
                      )}

                      <div className="col-4">
                        <div className="info-block">
                          <div className="info-label">Designation: </div>
                          <div className="info-value">{profileData.designation || "-"}</div>
                        </div>
                      </div>
                      <div className="col-4">
                        <div className="info-block">
                          <div className="info-label">Experience: </div>
                          <div className="info-value">  {profileData.years_experience ? `${profileData.years_experience} years` : "-"}</div>
                        </div>
                      </div>
                      <div className="col-4">
                        <div className="info-block">
                          <div className="info-label">Current Role: </div>
                          <div className="info-value">{profileData.current_role_position || "-"}</div>
                        </div>
                      </div>
                      <div className="col-4">
                        <div className="info-block">
                          <div className="info-label">State: </div>
                          <div className="info-value">{profileData.state || "-"}</div>
                        </div>
                      </div>
                      <div className="col-4">
                        <div className="info-block">
                          <div className="info-label">Employee Id: </div>
                          <div className="info-value">{profileData.employee_id || "-"}</div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="section-wrapper mb-4">
                  <h5 className="heading">Skills & Interests</h5>
                  <div className="card p-4 shadow-sm">
                    <div className="row g-3">
                      <div className="col-md-12">
                        <div className="info-block">
                          <div className="info-label">Languages: </div>
                          <div className="info-value">{profileData.languages || "-"}</div>
                        </div>
                      </div>
                      <div className="col-md-12">
                        <div className="info-block">
                          <div className="info-label">Frameworks: </div>
                          <div className="info-value">{profileData.frameworks || "-"}</div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                </>:<></>}
                <div className="section-wrapper mb-4">
                  <h5 className="heading">Projects
                    {projectData?.length > 0 &&
                      ` (${projectData.length})`
                    }
                  </h5>
                  <div className="card p-4 shadow-sm" style={{ maxHeight: "350px", overflowY: "auto" }}>
                    {(!projectData || projectData.length === 0) && (
                      <div
                        className="text-center"
                        style={{ fontSize: "1rem", color: "#545454" }}
                      >
                        No project found
                      </div>
                    )}
                    {projectData?.map((project, index) => (
                      <div key={index} className="project-item">
                        <h6 className="project-title">{project.group_name}</h6>
                        <p className="project-summary">{project.short_description}</p>
                        {index !== projectData.length - 1 && <div className="divider"></div>}
                      </div>
                    ))}
                  </div>
                </div>
                {showProfile ?
                <div className="section-wrapper mb-4">
                  <h5 className="heading">
                    Certificates
                    {certificateData.fetch_records?.length > 0 &&
                      ` (${certificateData.fetch_records.length})`
                    }
                  </h5>
                  <div className="card p-4 shadow-sm">
                    <div className="row g-3 justify-content-center">
                      {/* Handle empty state */}
                      {(!certificateData.fetch_records || certificateData.fetch_records.length === 0) && (
                        <div className="text-center" style={{ fontSize: "1rem", color: "#595959", width: "100%" }}>
                          No certificates found
                        </div>
                      )}

                      {/* Render certificates */}
                      {certificateData.fetch_records?.map((cert) => {
                        const certUrl = `${BASE_URL_OPENFORGE}/certificate/${cert.uri}`; // full URL to open

                        return (
                          <div
                            key={cert._id}
                            className="col-6 col-sm-6 col-md-2 col-lg-2 d-flex justify-content-center"
                          >
                            <div
                              className="info-block"
                              style={{
                                textAlign: "center",
                                width: "100%",
                                padding: "0 8px",
                                cursor: "pointer", // indicate clickable
                              }}
                              onClick={() => window.open(certUrl, "_blank")} // open in new tab
                            >
                              <img
                                src={`${process.env.PUBLIC_URL}/img/sample_certificate.png`}
                                alt={cert.task_name}
                                style={{ width: "100%", borderRadius: "8px" }}
                              />
                              <div
                                className="info-value"
                                style={{
                                  marginTop: "6px",
                                  fontSize: "0.9rem",
                                  overflow: "hidden",
                                  textOverflow: "ellipsis",
                                  whiteSpace: "nowrap",
                                }}
                                title={cert.task_name} // <-- Tooltip on hover

                              >
                                {cert.task_name}
                              </div>
                            </div>
                          </div>
                        );
                      })}
                    </div>
                  </div>

                </div>
                :<></>}
              </div>
            )}
      </div>
    </main>
  );
}
